import type { OnboardingTemplate } from 'src/interfaces/onboardingTemplate'

/**
 * The editor's starting point in new-template mode: a structurally empty template that stands in
 * for the not-yet-persisted one, so `template` and `savedSnapshot` stay non-null and every derived
 * view, validator and the unsaved-changes guard keep working unchanged.
 *
 * Deliberately empty — the only real value is the partner id. Nothing here is placeholder business
 * content; the name comes from the user and the groups and steps from the draft.
 */
export function emptyOnboardingTemplate(partnerId: string): OnboardingTemplate {
  return {
    id: '',
    name: '',
    partnerId,
    collectDataTemplateStepsConfigs: [],
  }
}
